const API_CONSTS = {
  RETRIEVE_AUTHORIZATION_CODE_RESPONSE: "RETRIEVE_AUTHORIZATION_CODE",
  AUTH_API_PATH: "auth-v2",
};

const APPLICATION_ID_CONSTS = {
  EPM: "Brand",
  ASK_Treez: "Ask",
};

const LOGIN_ERRORS = {
  DEFAULT: {
    // catch all error: no api response text match needed
    // copy to use in UI rendering
    userErrorMessage:
      "We are sorry, we encountered an error when signing you in. Try again and contact support if the issue continues.",
  },
  INVALID_CREDENTIALS: {
    apiResponse: "Username and/or password is invalid",
    // copy to use in UI rendering
    userErrorMessage:
      "Incorrect email and/or password. Check your credentials and try again.",
  },
  MAX_ATTEMPTS: {
    apiResponse:
      "Account locked due to exceeding the maximum number of incorrect login attempts",
    // copy to use in UI rendering
    userErrorMessage:
      "Your account has been locked after 5 failed attempts. Reset your password or try again in 15 minutes.",
  },
};

const RESET_PASSWORD_ERRORS = {
  DEFAULT: {
    // catch all error: no api response text match needed
    // copy to use in UI rendering
    userErrorMessage:
      "We are sorry, we encountered an error when resetting your password. Try again and contact support if the issue continues.",
  },
  DUPLICATE_PASSWORD: {
    apiResponse:
      "The provided new password cannot be the same as the current password or any password in the user's password history.",
    // copy to use in UI rendering
    userErrorMessage:
      "New password cannot be the same as your current password. Enter a new password and try again.",
  },
};

const SESSION_STORAGE_CONSTS = {
  APPLICATION_ID: "applicationId",
  CALLBACK_URL: "callbackUrl",
};

const VERIFICATION_CODE_ERRORS = {
  DEFAULT: {
    // catch all error: no api response text match needed
    // copy to use in UI rendering
    userErrorMessage:
      "We are sorry, we encountered an error when sending a verification code. Try again and contact support if the issue continues.",
  },
};

export {
  API_CONSTS,
  APPLICATION_ID_CONSTS,
  LOGIN_ERRORS,
  RESET_PASSWORD_ERRORS,
  SESSION_STORAGE_CONSTS,
  VERIFICATION_CODE_ERRORS,
};
